import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import styles for Quill editor

export default function BlogApp() {
    const [showCreateBlog, setShowCreateBlog] = useState(false);
    const [blogs, setBlogs] = useState([]);
    const [inputs, setInputs] = useState({
        btitle: "", authorname: "", slugurl: "", blogtext: "", bimg: null
    });

    useEffect(() => {
        fetchBlogs();
    }, []);

    const fetchBlogs = async () => {
        const response = await axios.get("https://harasky.com/api/user/api.php");
        setBlogs(response.data);
    };

    const handleChange = (event) => {
        const { name, value, type, files } = event.target;
        setInputs((prev) => type === "file" ? { ...prev, [name]: files[0] } : { ...prev, [name]: value });
    };

    // Handle text editor change
    const handleEditorChange = (content) => {
        setInputs((prev) => ({ ...prev, blogtext: content }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        const formData = new FormData();
        Object.keys(inputs).forEach((key) => formData.append(key, inputs[key]));

        await axios.post("https://harasky.com/api/user/api.php", formData, { headers: { "Content-Type": "multipart/form-data" } });
        fetchBlogs();
        setShowCreateBlog(false);
    };

    const handleEdit = (blog) => {
        setInputs(blog);
        setShowCreateBlog(true);
    };

    const handleUpdate = async (event) => {
        event.preventDefault();
        await axios.put("https://harasky.com/api/user/api.php", inputs);
        fetchBlogs();
        setShowCreateBlog(false);
    };

    const handleDelete = async (id) => {
        await axios.delete(`https://harasky.com/api/user/api.php?id=${id}`);
        fetchBlogs();
    };

    return (
        <div className="container">
            <div className="row mt-5 mb-5">
                <div className="col-md-12">
                    <div className="btnDiv">
                        <button className="btn btn-success" onClick={() => setShowCreateBlog(!showCreateBlog)}>
                            {showCreateBlog ? "Show Blogs" : "Create Blog"}
                        </button>
                    </div>
                </div>
            </div>

            {!showCreateBlog && (
                <div className="showblogs">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="tableforBlogdata">
                                <table className="table table-bordered table-responsive">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Title</th>
                                            <th>Author Name</th>
                                            <th>Image</th>
                                            <th>Date</th>
                                            <th>Edit</th>
                                            <th>Delete</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {blogs.map((blog) => (
                                            <tr key={blog.id}>
                                                <td>{blog.id}</td>
                                                <td>{blog.btitle}</td>
                                                <td>{blog.authorname}</td>
                                                <td>
                                                    <img src={`https://harasky.com/api/uploads/${blog.bimg}`} alt="Blog" width="50" />
                                                </td>
                                                <td>{blog.bdate}</td>
                                                <td>
                                                    <button className="btn btn-primary" onClick={() => handleEdit(blog)}>Edit</button>
                                                </td>
                                                <td>
                                                    <button className="btn btn-danger" onClick={() => handleDelete(blog.id)}>Delete</button>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showCreateBlog && (
                <div className="CreateBlog">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card p-5 mt-5 mb-5 bg-success">
                                <h2 className="text-center text-white">Create Blog</h2>
                                <form onSubmit={inputs.id ? handleUpdate : handleSubmit}>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <label className="text-white mb-2 mt-3">Title</label>
                                            <input type="text" className="form-control" name="btitle" value={inputs.btitle} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="text-white mb-2 mt-3">Author Name</label>
                                            <input type="text" className="form-control" name="authorname" value={inputs.authorname} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="text-white mb-2 mt-3">Slug Url</label>
                                            <input type="text" className="form-control" name="slugurl" value={inputs.slugurl} onChange={handleChange} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="text-white mb-2 mt-3">Select Image</label>
                                            <input type="file" className="form-control" name="bimg" onChange={handleChange} />
                                        </div>
                                        <div className="col-md-12">
                                            <label className="text-white mb-2 mt-3">Write About Your Blog</label>
                                            <ReactQuill 
                                                theme="snow"
                                                value={inputs.blogtext}
                                                onChange={handleEditorChange}
                                                style={{ background: "white", minHeight: "300px" }}
                                            />
                                        </div>
                                        <div className="col-md-12 text-center">
                                            <button className="btn btn-warning mt-3" type="submit">{inputs.id ? "Update" : "Publish"}</button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
